import React from 'react';
import { Typography } from '@mui/material';

import { PrimarySkillsRanking } from '@constants';
import { rankingDotColor } from 'theme/ranking';
import { DotValue } from './DotValue';

export const RankingValue: React.FC<{ value: PrimarySkillsRanking | null }> = ({
  value,
}) => {
  if (!value)
    return (
      <Typography variant="body1" color="text.lightGrey">
        Not rated
      </Typography>
    );

  return (
    <DotValue color={(palette) => rankingDotColor(palette)[value]}>
      {value}
    </DotValue>
  );
};
